<template>
  <v-navigation-drawer
    v-model="drawer"
    id="core-navigation-drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
    color="#808080"
    v-if="!hideDrawer"
    :mini-variant.sync="mini"
    class="custom-drawer"
  >
    <template v-slot:prepend>
      <v-list-item two-line router to="/userprofile" class="profile-item mt-2 mb-n2 ml-n2 ">
        <v-list-item-avatar class="avatar-border">
          <img :src="profileimg" />
        </v-list-item-avatar>

        <v-list-item-content class="ml-1">
          <v-list-item-title class="text-body-2">{{
              userName
            }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-list nav>
      <v-divider></v-divider>
      <v-list-group prepend-icon="account_circle" :value="false" v-if="checkRole">
        <template v-slot:activator>
          <v-list-item-title>Admin</v-list-item-title>
        </template>
        <v-list-group no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Client</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="client in clients"
            :key="client.title"
            router
            :to="client.route"
            class="ml-n12"
          >
            <v-list-item-title class="pl-10">{{
                client.text
              }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Staff</v-list-item-title>
              <v-row align="center" justify="end"  class="pa-2" v-show="userNotification != 0 ">
                <v-badge
                  bottom
                  color="red"
                  offset-x="30"
                  offset-y="21"
                  :content="userNotification"
                >
                </v-badge>
              </v-row>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="employee in employees"
            :key="employee.title"
            router
            :to="employee.route"
            class="ml-n12"
          >
            <v-list-item-title class="pl-10">{{
                employee.text
              }}</v-list-item-title>

            <v-list-item-icon v-show=" employee.text === 'Users' && userNotification != 0 ">
              <v-badge
                bottom
                color="red"
                offset-x="15"
                offset-y="10"
                :content="userNotification"
              >
                <v-icon>{{ employee.icon }}</v-icon>
              </v-badge>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group v-if="checkRole">
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Program Dashboards</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="program in programDashboards"
              :key="program._id"
              router
              :to="`/programDashboard/${program._id}`"
              class="ml-n12"
            >
              <v-list-item-title class="pl-10">{{
                program.Name
              }}</v-list-item-title>
            </v-list-item>
        </v-list-group>

        <v-list-group no-action sub-group v-if="isDevelopment">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>
                Settings
                <v-chip
                  x-small
                  color="primary"
                  class="ml-2"
                >
                  Beta
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="setting in settings"
            :key="setting.title"
            router
            :to="setting.route"
            class="ml-n12"
          >
            <v-list-item-title class="pl-10">{{
                setting.text
              }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- Company -->
        <v-list-group v-if="userRole==='SuperAdministrator'" no-action sub-group>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Company</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="companyOption in companyOptions"
            :key="companyOption.title"
            router
            :to="companyOption.route"
            class="ml-n12"
          >
            <v-list-item-title class="pl-10">{{
                companyOption.text
              }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list-group>
      <!--
      <v-list-item
        v-for="dash in dashboard"
        :key="dash.route"
        router
        :to="dash.route"
      >-->
      <v-list-item router to="#" @click="goDashboard()" v-if="!pharmacy">
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>

        <v-list-item-title>Dashboard</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-for="company in companies"
        :key="company.text"
        router
        :to="company.route"
      >
        <v-list-item-icon>
          <v-icon>{{ company.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ company.text }}
            <v-chip
              v-if="company.status === 'beta'"
              x-small
              color="primary"
              class="ml-2"
            >
              Beta
            </v-chip>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>

/*eslint-disablle */
import { mapState } from "vuex";
import axios from "axios";
const url = require("@/client_config/config").url;
import { mapGetters, mapActions } from "vuex";


export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    profileimg: "",
    userID: "",
    userName: "",
    user: [],
    dashboard: [{ route: "/staffInfo" }],
    sidebar: [],
    administration: false,
    regionalDirector: false,
    directCareStaff: false,
    programManager: false,
    houseManager: false,
    assistantManager: false,
    humanResources: false,
    humanResourcesAssistant: false,
    clientServicesManager: false,
    medicalManager: false,
    programCoordinator: false,
    executiveDirector: false,
    financeManager: false,
    complianceManager: false,
    parentGuardian: false,
    supportCoordinator: false,
    client: false,
    pharmacy: false,
    auditor: false,
    hideDrawer: false,
    companies: [
      { text: "Schedule", icon: "schedule", route: "/shifts" },
      { text: "Staff", icon: "person", route: "/employees" },
      { text: "Clients", icon: "accessibility_new", route: "/client" },
      { text: "Reports", icon: "bar_chart", route: "/reports" },
      { text: "Calendar", icon: "event", route: "/calendar" },
      { text: "Training", icon: "school", route: "/training" },
      { text: "Training History", icon: "history", route: "/training-history" },
      { text: "Tasks", icon: "check_circle", route: "/tasks" },
      { text: "Maintenance", icon: "build", route: "/HouseMaintenance" },
      { text: "Transportation", icon: "airport_shuttle", route: "/Transportation" },
      { text: "Vehicles", icon: "directions_car", route: "/Vehicles" },
      // { text: "Chat", icon: "message", route: "/chat" },
      // { text: "Performance Review", icon: "rate_review", route: "/performanceReview" }, NOTE: Temporarily Hide this Route

      // { text: "Zoom", icon: "videocam", route: "/zoom" },
    ],
    clients: [{ text: "Service Codes", icon: "person", route: "/codes" }],
    settings: [{ text: "Roles and Permission", icon: "check_circle", route: "/roles-permission" }],
    employees: [
      { text: "Clock In Tracker", icon: "check", route: "/clockInTracker" },
      { text: "LogIn/LogOut Tracker", icon: "check", route: "/userAuthLog" },
      { text: "Certifications", icon: "check", route: "/staffCertification" },
      { text: "Notifications", icon: "schedule", route: "/notifications" },
      { text: "Programs", icon: "apartment", route: "/unit" },
      { text: "Users", icon: "person", route: "/users" },
      {text: "Users Roles", icon: "person", route: "/usersRoles" },
      { text: "Training", icon: "person", route: "/globalTraining" },
      { text: "NHO", icon: "person", route: "/nho" },
    ],
    companyOptions: [
      { text: "Settings", icon: "check_circle", route: "/companies"}
    ],
    programDashboards: [],
    userRole: localStorage.getItem('userRole'),
    devAccounts: [ //Note: test email to show calendar with google api integration in production
      "admin@staging-living-app.com",
      "admin@climate-rx.com",
      "admin@innovacare.com"
    ]
  }),
  created() {
    //if(process.env.NODE_ENV === 'development' || this.devAccounts.includes(this.$store.state.users.user.Email) ) {
    this.companies.splice(5, 0, {
      text: "Calendar New",
      icon: "event",
      route: "/new/calendar",
      status: 'beta'
    })
    // }
    this.fetch()
    this.fetchProgramDashboards()
    this.userID = localStorage.getItem('userID');
    this.getUserInfo(this.userID);
    if(localStorage.getItem('userRole')=="Administration" || localStorage.getItem('userRole')=="SuperAdministrator"){
      this.administration = true;
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      let payroll = { text: "Payroll", icon: "account_balance", route: "/payroll" }
      this.companies.push(providers, payroll)
    }else if( localStorage.getItem('userRole')=="Direct Care Staff"){
      this.directCareStaff = true;
      this.sidebar=[0]
      this.companies = [
        { text: "Schedule", icon: "schedule", route: "/shifts" },
        { text: "Staff", icon: "person", route: "/employees" },
        { text: "Clients", icon: "accessibility_new", route: "/client" },
        // { text: "Reports", icon: "bar_chart", route: "/reports" },
        { text: "Calendar", icon: "event", route: "/calendar" },
        { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" },
        { text: "Training", icon: "school", route: "/training" },
        { text: "Training History", icon: "history", route: "/training-history" },
        // { text: "Chat", icon: "message", route: "/chat" },
        // { text: "Tasks", icon: "check_circle", route: "/tasks" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ]

    }else if( localStorage.getItem('userRole')=="Shift Lead"){
      this.assistantManager = true;
      this.sidebar=[0]
      this.companies = [
        { text: "Schedule", icon: "schedule", route: "/shifts" },
        { text: "Staff", icon: "person", route: "/employees" },
        { text: "Clients", icon: "accessibility_new", route: "/client" },
        // { text: "Reports", icon: "bar_chart", route: "/reports" },
        { text: "Calendar", icon: "event", route: "/calendar" },
        { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" },
        { text: "Training", icon: "school", route: "/training" },
        { text: "Training History", icon: "history", route: "/training-history" },
        // { text: "Chat", icon: "message", route: "/chat" },
        // { text: "Tasks", icon: "check_circle", route: "/tasks" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ]

    }else if( localStorage.getItem('userRole')=="Assistant Manager"){
      this.assistantManager = true;
      this.sidebar=[0]
      this.companies = [
        { text: "Schedule", icon: "schedule", route: "/shifts" },
        { text: "Staff", icon: "person", route: "/employees" },
        { text: "Clients", icon: "accessibility_new", route: "/client" },
        { text: "Reports", icon: "bar_chart", route: "/reports" },
        { text: "Calendar", icon: "event", route: "/calendar" },
        { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" },
        { text: "Transportation", icon: "airport_shuttle", route: "/Transportation" },
        { text: "Training", icon: "school", route: "/training" },
        { text: "Training History", icon: "history", route: "/training-history" },
        // { text: "Tasks", icon: "check_circle", route: "/tasks" },
        //{ text: "Chat", icon: "message", route: "/chat" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ]

    }else if( localStorage.getItem('userRole')=="Program Manager"){
      this.programManager = true;
      this.sidebar=[0]
      this.companies = [
        { text: "Schedule", icon: "schedule", route: "/shifts" },
        { text: "Staff", icon: "person", route: "/employees" },
        { text: "Clients", icon: "accessibility_new", route: "/client" },
        { text: "Reports", icon: "bar_chart", route: "/reports" },
        { text: "Calendar", icon: "event", route: "/calendar" },
        { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" },
        { text: "Transportation", icon: "airport_shuttle", route: "/Transportation" },
        { text: "Training", icon: "school", route: "/training" },
        { text: "Training History", icon: "history", route: "/training-history" },
        { text: "Tasks", icon: "check_circle", route: "/tasks" },
        //{ text: "Chat", icon: "message", route: "/chat" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ]
    }else if( localStorage.getItem('userRole')=="House Manager"){
      this.houseManager = true;
      this.sidebar=[0]
      this.companies = [
        { text: "Schedule", icon: "schedule", route: "/shifts" },
        { text: "Staff", icon: "person", route: "/employees" },
        { text: "Clients", icon: "accessibility_new", route: "/client" },
        { text: "Reports", icon: "bar_chart", route: "/reports" },
        { text: "Calendar", icon: "event", route: "/calendar" },
        { text: "Fire Drill", icon: "whatshot", route: "/fireDrill" },
        { text: "Training", icon: "school", route: "/training" },
        { text: "Training History", icon: "history", route: "/training-history" },
        { text: "Tasks", icon: "check_circle", route: "/tasks" },
        { text: "Maintenance", icon: "build", route: "/HouseMaintenance" },
        //{ text: "Chat", icon: "message", route: "/chat" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ]

    }else if( localStorage.getItem('userRole')=="Human Resources"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      let payroll = { text: "Payroll", icon: "account_balance", route: "/payroll" }
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, payroll, maintenance)
      this.humanResources = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Human Resources Assistant"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      let payroll = { text: "Payroll", icon: "account_balance", route: "/payroll" }
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, payroll, maintenance)
      this.humanResourcesAssistant = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Client Services Manager"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, maintenance)
      this.companies.push(providers)
      this.clientServicesManager = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Medical Manager"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, maintenance)
      this.medicalManager = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Program Coordinator"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      // let payroll = { text: "Payroll", icon: "message", route: "/payroll" }
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, maintenance)
      this.programCoordinator = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Regional Director"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      // let payroll = { text: "Payroll", icon: "message", route: "/payroll" }
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, maintenance)
      this.regionalDirector = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Executive Director"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      // let payroll = { text: "Payroll", icon: "message", route: "/payroll" }
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, maintenance)
      this.executiveDirector = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Finance Manager"){
      let payroll = { text: "Payroll", icon: "account_balance", route: "/payroll" }
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(payroll, maintenance)
      this.financeManager = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Compliance Manager"){
      let providers = { text: 'Providers', icon: 'group', route: '/GlobalProvider'}
      // let payroll = { text: "Payroll", icon: "message", route: "/payroll" }
      let maintenance = { text: "Maintenance", icon: "check_circle", route: "/HouseMaintenance" }
      this.companies.push(providers, maintenance)
      this.complianceManager = true;
      this.sidebar=[0]

    }else if( localStorage.getItem('userRole')=="Parent/Guardian"){
      this.parentGuardian = true;
      this.sidebar=[0]
      this.companies = [
        // { text: "Shifts", icon: "schedule", route: "/shifts" },
        // { text: "Staff", icon: "person", route: "/employees" },
        { text: "Client", icon: "accessibility_new", route: "/clientInfo" },
        // { text: "Reports", icon: "bar_chart", route: "/reports" },
        // { text: "Calendar", icon: "event", route: "/calendar" },
        // { text: "Training", icon: "school", route: "/training" },
        // { text: "Tasks", icon: "check_circle", route: "/tasks" },
        // { text: "Chat", icon: "message", route: "/chat" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ],
        this.dashboard = []

    } else if( localStorage.getItem('userRole')=="Support Coordinator"){
      this.supportCoordinator = true;
      this.sidebar=[0]
      this.companies = [
        // { text: "Shifts", icon: "schedule", route: "/shifts" },
        // { text: "Staff", icon: "person", route: "/employees" },
        // { text: "Clients", icon: "accessibility_new", route: "/client" },
        // { text: "Reports", icon: "bar_chart", route: "/reports" },
        // { text: "Calendar", icon: "event", route: "/calendar" },
        // { text: "Training", icon: "school", route: "/training" },
        // { text: "Tasks", icon: "check_circle", route: "/tasks" },
        // { text: "Chat", icon: "message", route: "/chat" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ],
        this.dashboard = []

    } else if( localStorage.getItem('userRole')=="Client"){
      this.hideDrawer = true;
      this.companies = []
    } else if (localStorage.getItem('userRole')=='Pharmacy'){
      this.pharmacy = true
      this.companies = [
        // { text: "Shifts", icon: "schedule", route: "/shifts" },
        // { text: "Staff", icon: "person", route: "/employees" },
        { text: "Clients", icon: "accessibility_new", route: "/Client" },
        // { text: "Reports", icon: "bar_chart", route: "/reports" },
        // { text: "Calendar", icon: "event", route: "/calendar" },
        // { text: "Training", icon: "school", route: "/training" },
        // { text: "Tasks", icon: "check_circle", route: "/tasks" },
        // { text: "Chat", icon: "message", route: "/chat" },
        // { text: "Zoom", icon: "videocam", route: "/zoom" },
      ]
    }
    else if (localStorage.getItem('userRole')=='Auditor'){
      this.pharmacy = true
      this.companies = [
        { text: "Staff", icon: "person", route: "/employees" },
        { text: "Clients", icon: "accessibility_new", route: "/Client" },
      ]
    }
    //this.getNotifications();
  },

  computed: {
    ...mapState(["barColor", "barImage"]),
    ...mapGetters("users", ["getAllUsers"]),
    checkRole() {
      let role = ""
      if(this.administration){
        return role = this.administration
      } else if (this.humanResources){
        return role = this.humanResources
      } else if (this.executiveDirector){
        return role = this.executiveDirector
      }
      return role
    },
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      },
    },
    miniDrawer: {
      get() {
        return this.$store.state.miniDrawer;
      },
      set(val) {
        this.$store.commit("SET_MINI_DRAWER", val);
      },
    },
    mini(){
      return this.miniDrawer && !this.$vuetify.breakpoint.smAndDown
    },
    userNotification(){
      return this.getAllUsers.filter(item => item.Progress === 100 && item.VerificationStatus != "Verified").length
    },
    isDevelopment() {
      return process.env.NODE_ENV === 'development';
    }
  },

  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    },
  },

  methods: {
    ...mapActions({
      fetchAllUsers: "users/fetchAllUsers",
      fetchMessages: "fetchMessages",
    }),
    getUserInfo: function(id) {
      axios.get(`${url}/users/${id}`).then((res) => {
        this.userName = res.data.user.Name;
        this.profileimg = res.data.user.Image;
      });
    },

    async fetch(){
      await this.fetchAllUsers()
      await this.fetchMessages()
    },

    async fetchProgramDashboards() {
      try {
        // Get user's assigned programs from localStorage
        const userPrograms = JSON.parse(localStorage.getItem('userPrograms') || '[]');
        const userCompanies = JSON.parse(localStorage.getItem('userCompanies') || '[]');
        
        if (userPrograms && userPrograms.length > 0) {
          // Filter programs by user's assigned programs
          const response = await axios.get(`${url}/units/status/company`, {
            params: { Company: userCompanies }
          });
          
          // Filter the response to only include programs assigned to the user
          const allPrograms = response.data.units || [];
          this.programDashboards = allPrograms
            .filter(program => userPrograms.includes(program.Name))
            .sort((a, b) => {
              if (!a.Name) return 1;
              if (!b.Name) return -1;
              return a.Name.localeCompare(b.Name);
            });
        } else {
          this.programDashboards = [];
        }
      } catch (error) {
        console.error('Error fetching program dashboards:', error);
        this.programDashboards = [];
      }
    },

    goDashboard(){
      window.localStorage.setItem('staffId', localStorage.getItem('userID'));
      window.location.href = '/staffInfo/'+localStorage.getItem('userID');
    }
  },

};
</script>

<style scoped>

.profile-item {
  background-color: transparent;
}

.avatar-border {
  border: 2px solid #3498db;
  box-shadow: 0 0 8px rgba(52, 152, 219, 0.5);
}

.custom-drawer {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  background: linear-gradient(to bottom, #2c3e50, #1e1e1e);
}

.custom-list {
  padding-top: 2px;
}

.menu-item {
  border-radius: 2px;
  margin: 0 2px;
  transition: all 0.2s ease;
}

.v-list-group__header {
  padding-left: 2px;
}

.v-list-item__title {
  font-size: 0.85em;
  font-weight: 400;
}

.v-list-group__header {
  padding: 2px 6px;
  min-height: 28px;
}

.v-icon {
  font-size: 16px;
}

.v-list-group {
  margin-bottom: 1px;
}

.v-list-group__items .v-list-item {
  padding-left: 2px;
  min-height: 30px;
}

.v-list > .v-list-group + .v-list-group,
.v-list > .v-list-item + .v-list-item {
  margin-top: 1px;
}
</style>
